import React from 'react';
import { PropsWithChildren } from "react"

const ModalHeader = ({children}: PropsWithChildren<{}>) => {
    return (
        <div className={`tw-border-b  !tw-px-6 !tw-py-2`}>
            {children}
        </div>
    )
}
export default ModalHeader